"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertTypeInCtx = void 0;
const Errors = __importStar(require("../errors"));
const value_1 = require("../value");
function assertTypeInCtx(mod, ctx, type, kind) {
    if (type["@kind"] !== kind) {
        throw new Errors.AssertionError([
            `assertTypeInCtx fail`,
            `  expect type kind: ${kind}`,
            `  found type: ${(0, value_1.formatType)(mod, ctx, type)}`,
        ].join("\n"));
    }
}
exports.assertTypeInCtx = assertTypeInCtx;
//# sourceMappingURL=assertTypeInCtx.js.map